<template>
    <div>
        <header class="header">
            <div class="container">
                <div class="row align-items--center">
                    <div class="col-2">
                        <button  class="btn btn--icon btn--white" @click.prevent="handleBack('/')">
                            <i class="material-icons">keyboard_arrow_left</i>
                        </button>
                    </div>

                    <div class="col-8">
                        <h1 class="header__title">History</h1>
                    </div>

                    <div class="col-2 text--right">
                        <router-link to="/" class="btn btn--icon btn--white">
                            <i class="material-icons">close</i>
                        </router-link>
                    </div>
                </div>
            </div>
        </header>

        <section class="container animated fadeIn">
            <div class="intro-content pt--40 pb--20">
                <div class="profile profile--vertical profile--lg mb--30">
                    <figure class="profile__avatar">
                        <span class="profile__avatar__img">
                            <img :src="avatar" alt="" />
                        </span>
                    </figure>

                    <div class="profile__text">
                        <div class="profile__name">{{ user.nick }}</div>
                    </div>
                </div>
            </div>

            <div class="panel bg--layer-dark mb--40" v-if="games">
                <table class="table-status text--sm">
                    <tr v-for="game in games">
                        <td>
                            <div class="profile profile--inline profile--horizontal">
                                <figure class="profile__avatar">
                                    <span class="profile__avatar__img">
                                        <img v-bind:src="game.opponentAvatar"/></span>
                                </figure>

                                <div class="profile__text">
                                    <div class="profile__name profile__name--max-width">
                                        {{ game.opponent }}
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td>{{ game.date }}</td>
                        <td>{{ game.result }}</td>
                        <td class="text--right">
                            <i class="material-icons" v-if="game.isWinner">check</i>
                            <i class="material-icons" v-else>close</i>
                        </td>
                    </tr>
                </table>
            </div>
        </section>
    </div>
</template>

<script>
    import api from "../api/profile";
    import { mapState, mapGetters } from 'vuex'
    import internalBackRoute from "../mixins/internalBackRoute";

    export default {
        name: "GameHistory",
        data: function () {
            return {
                games: null
            }
        },
        mixins: [internalBackRoute],
        methods: {
            async loadGameHistory() {
                try {
                    let response = await api.loadGameHistory()
                    this.games = response.data
                } catch (e) {
                    Quiz.$emit('game-hsitory-load-error')
                }
            }
        },
        computed: {
            ...mapState('auth', [
                'user'
            ]),

            ...mapGetters('auth', [
                'avatar',
            ]),
        },

        created() {
            this.loadGameHistory();
        }
    }
</script>